export const Categories = Object.freeze({
  M10M: "M10M",
  M10F: "M10F",
  M9M: "M9M",
  M9F: "M9F",
  M8M: "M8M",
  M8F: "M8F",
  M7M: "M7M",
  M7F: "M7F",
  M6M: "M6M",
  M6F: "M6F",
  M5M: "M5M",
  M5F: "M5F",
  M4M: "M4M",
  M4F: "M4F",
  M3M: "M3M",
  M3F: "M3F",
  M2M: "M2M",
  M2F: "M2F",
  M1M: "M1M",
  M1F: "M1F",
  M0M: "M0M",
  M0F: "M0F",

  SEM: "SEM",
  SEF: "SEF",
  ESM: "ESM",
  ESF: "ESF",
  JUM: "JUM",
  JUF: "JUF",
  CAM: "CAM",
  CAF: "CAF",
  MIM: "MIM",
  MIF: "MIF",
  BEM: "BEM",
  BEF: "BEF",
  POM: "POM",
  POF: "POF",
  EAM: "EAM",
  EAF: "EAF",
  BBM: "BBM",
  BBF: "BBF",
});

export const getNearestYoungerCategory = (category, categoriesToCheck) => {
  let sortedCategories = Object.keys(Categories);

  if (category.endsWith("M")) {
    sortedCategories.filter((c) => c.endsWith("M"));
  } else if (category.endsWith("F")) {
    sortedCategories.filter((c) => c.endsWith("F"));
  }
  sortedCategories = sortedCategories.filter((c) =>
    categoriesToCheck.includes(c)
  );
  return sortedCategories[0];
};
